<template>
  <transition name="connection-banner">
    <div v-if="showBanner" class="connection-banner" :class="bannerClass">
      <div class="connection-banner__content">
        <v-progress-circular
            v-if="bannerType === 'info'"
            indeterminate
            size="14"
            width="2"
            color="#d32f2f"
            class="connection-banner__spinner"
        />
        <span class="connection-banner__text">{{ bannerMessage }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ConnectionBanner',
  computed: {
    ...mapGetters('Connection', ['showBanner', 'bannerMessage', 'bannerType']),
    bannerClass() {
      return `connection-banner--${this.bannerType}`;
    },
  },
};
</script>

<style scoped>
.connection-banner {
  width: 100%;
  padding: 10px 16px;
  text-align: center;
  z-index: 100;
  background-color: #ffffff;
}

.connection-banner__content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.connection-banner__text {
  font-size: 14px;
  font-weight: 700;
  font-family: Roboto, sans-serif;
}

.connection-banner__spinner {
  flex-shrink: 0;
}

/* No connection / server unreachable — red text */
.connection-banner--error .connection-banner__text,
.connection-banner--warning .connection-banner__text,
.connection-banner--info .connection-banner__text {
  color: #d32f2f;
}

/* Reconnected — green text */
.connection-banner--success .connection-banner__text {
  color: #2e7d32;
}

/* Slide transition */
.connection-banner-enter-active,
.connection-banner-leave-active {
  transition: all 0.3s ease;
  max-height: 40px;
  overflow: hidden;
}

.connection-banner-enter,
.connection-banner-leave-to {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}
</style>
